import { useState, useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

function useUser() {
  const { baseUrl, basicAuth } = useContext(GlobalContext);

  const [people, setPeople] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);

  //  Invite User
  const inviteUser = async (payload) => {
    try {
      const res = await fetch(`${baseUrl}/User/inviteUser`, {
        method: "POST",
        headers: {
          Authorization: basicAuth,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      return await res.json();
    } catch (error) {
      console.error("inviteUser error:", error);
    }
  };

  //  Get Roles
  const getUserRoles = async (userID) => {
    try {
      const res = await fetch(`${baseUrl}/User/getUserRoles`, {
        method: "POST",
        headers: {
          Authorization: basicAuth,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userid: userID,
        }),
      });

      const data = await res.json();

      if (data?.responseCode === "00") {
        setRoles(data?.response);
      }

      return data;
    } catch (error) {
      console.error("getUserRoles error:", error);
    }
  };

  //  Change Status
  const changeUserStatus = async (payload) => {
    try {
      const res = await fetch(`${baseUrl}/User/changeUserStatus`, {
        method: "POST",
        headers: {
          Authorization: basicAuth,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      return await res.json();
    } catch (error) {
      console.error("changeUserStatus error:", error);
    }
  };

  //  Delete User
  const deleteUser = async (payload) => {
    try {
      const res = await fetch(`${baseUrl}/User/deleteUser`, {
        method: "POST",
        headers: {
          Authorization: basicAuth,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      return await res.json();
    } catch (error) {
      console.error("deleteUser error:", error);
    }
  };

  return {
    loading,
    people,
    roles,
    inviteUser,
    getUserRoles,
    changeUserStatus,
    deleteUser,
  };
}

export default useUser;
